import {
  Switch as SwitchIcon,
  Logout as LogoutIcon,
  HelpCenter as HelpCenterIcon,
  AccountPhoto as AccountPhotoIcon,
  MyProfileCMS as MyProfileIcon,
} from 'common/components/svgs';
import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Menu, Dropdown, Layout, Modal } from 'antd';
import { Link } from 'react-router-dom';
import GlobalSearch from '~components/global-search';
import { fireCustomEvent } from '~helpers/custom-events';
import { useCurrentRoles } from '~components/switch-role/useSwitchRole';

export default class Header extends React.Component {
  getMenu = () => (
    <Menu style={{ width: 160, padding: 0 }}>
      <Menu.Item className="dashboard-header__menu">
        <Link to="/account/my-profile" className="dashboard-header__link">
          <MyProfileIcon className="dashboard-header__menu-icon" />
          <span className="dashboard-header__menu-text">
            {this.props.t('cms.header.dropdown.menu.my_profile')}
          </span>
        </Link>
      </Menu.Item>
      <If
        condition={
          this.props.cmsUser &&
          this.props.cmsUser.userRoles &&
          this.props.cmsUser.userRoles.length > 1
        }
      >
        <Menu.Item className="dashboard-header__menu">
          <span onClick={this.handleSwitchRole} role="button" tabIndex="0" style={{ outline: 0 }}>
            <SwitchIcon className="dashboard-header__menu-icon" />
            <span className="dashboard-header__menu-text">
              {this.props.t('cms.header.dropdown.menu.switch_role')}
            </span>
          </span>
        </Menu.Item>
      </If>
      <Menu.Item className="dashboard-header__menu">
        <span onClick={this.logoutModal} role="button" tabIndex="0" style={{ outline: 0 }}>
          <LogoutIcon className="dashboard-header__menu-icon" />
          <span className="dashboard-header__menu-text">
            {this.props.t('cms.header.dropdown.menu.log_out')}
          </span>
        </span>
      </Menu.Item>
    </Menu>
  );

  logoutModal = () => {
    Modal.confirm({
      className: '',
      icon: <ExclamationCircleFilled />,
      title: this.props.t('cms.header.dropdown.menu.log_out.modal.title'),
      okText: this.props.t('cms.form.pop_confirm.yes'),
      cancelText: this.props.t('cms.form.pop_confirm.no'),
      width: 380,
      onOk: this.props.logoutUser,
    });
  };

  handleSwitchRole = () => {
    fireCustomEvent('triggerSwitchRole');
  };

  render() {
    const { location, history } = this.props;
    return (
      <Layout.Header className="dashboard-header">
        <LegacyIcon
          className="dashboard-header__trigger dashboard-header__item"
          type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
          onClick={this.props.toggleCollapseSidebar}
          style={{ color: '#9e9e9e' }}
        />
        <div className="dashboard-header__item dashboard-header__search">
          <If
            condition={
              location.pathname !== '/special-offers' &&
              location.pathname !== '/contract' &&
              location.pathname !== '/reviews' &&
              !location.pathname.match('/locations') &&
              !location.pathname.match('/reconciliation') &&
              !location.pathname.match('/referral/commission-plan') &&
              !location.pathname.match('/referral/payout-plan') &&
              !location.pathname.match('/referral/promotion') &&
              !location.pathname.match('/referral/partner') &&
              !location.pathname.match('/referral/payout')
            }
          >
            <GlobalSearch
              t={this.props.t}
              pathname={location.pathname}
              search={location.search}
              history={history}
            />
          </If>
        </div>
        <div className="dashboard-header__item">
          <Link to="/help-center" className="dashboard-header__help-center" target="_blank">
            <HelpCenterIcon className="dashboard-header__help-center-icon" />
          </Link>
          {
            <Dropdown overlay={this.getMenu}>
              <div>
                <HeaderInfo
                  firstName={this.props.cmsUser?.firstName}
                  lastName={this.props.cmsUser?.lastName}
                  currentRoleSlug={this.props.currentRoleSlug}
                />
              </div>
            </Dropdown>
          }
        </div>
      </Layout.Header>
    );
  }
}

const HeaderInfo = React.forwardRef(({ firstName, lastName, currentRoleSlug }, ref) => {
  const { userRoles } = useCurrentRoles();

  const current = userRoles?.find(role => role.slug === currentRoleSlug);
  return (
    <div ref={ref}>
      <span className="dashboard-header__user">
        <AccountPhotoIcon className="dashboard-header__icon" />
      </span>
      <div className="dashboard-header__user-details">
        <span className="dashboard-header__name">
          {firstName}&nbsp;{lastName}
        </span>
        <span className="dashboard-header__text">{current?.name}</span>
      </div>
    </div>
  );
});

Header.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.object,
  currentRoleSlug: PropTypes.string,
  cmsUser: PropTypes.object,
  logoutUser: PropTypes.func,
  history: PropTypes.object,
  collapsed: PropTypes.bool,
  toggleCollapseSidebar: PropTypes.func,
};

Header.defaultProps = {
  t: () => {},
  location: {},
  currentRoleSlug: '',
  cmsUser: {},
  logoutUser: () => {},
  history: {},
  collapsed: false,
  toggleCollapseSidebar: () => {},
};
